export function pickVisibleColumns(columns = [], visibilityConfig = {}) {
    return columns.filter((column) => visibilityConfig?.[column.key] !== false);
}

export function pickVisibleRowData(rows = [], columns = []) {
    const keys = new Set((columns || []).map((column) => column.key));
    return (rows || []).map((row) => {
        return Object.fromEntries(Object.entries(row || {}).filter(([key]) => keys.has(key)));
    });
}

export function buildSectionsFromConfig(sectionConfigs = []) {
    return (sectionConfigs || [])
        .filter((section) => section?.enabled !== false)
        .map((section) => {
            const columns = pickVisibleColumns(section.columns, section.columnVisibility);
            const rows = pickVisibleRowData(section.rows, columns);
            return {
                sheetName: section.sheetName,
                tabColor: section.tabColor,
                title: section.title,
                description: section.description,
                tooltips: section.tooltips,
                columns,
                rows
            };
        })
        .filter((section) => section.columns?.length > 0);
}
